import { connect, ConnectedProps } from 'react-redux'

import ContentComponent from 'components/accordion/ContentComponent'
import { RootState } from 'redux/store';

const mapStateToProps = (state: RootState) => ({
  editMode: state.legislation.editMode,
  AdminButton: state.legislation.editMode,
  ContentEditor: state.legislation.editMode,
  flavour: state.layout.flavour
})

export const connector = connect(mapStateToProps, null)
export type ContentContainerProps = ConnectedProps<typeof connector>

export default connect(mapStateToProps, null)(ContentComponent)
